import { render, staticRenderFns } from "./upload-model.vue?vue&type=template&id=6e5ad944&scoped=true&"
import script from "./upload-model.vue?vue&type=script&lang=ts&"
export * from "./upload-model.vue?vue&type=script&lang=ts&"
import style0 from "./upload-model.vue?vue&type=style&index=0&id=6e5ad944&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e5ad944",
  null
  
)

export default component.exports